export default {
  contactTypes: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/contactTypes/state.js